/**
 * Build an Elation patient chart URL for the current PHC host.
 *
 * Dev / lifeomic-dev hosts (and local) use sandbox; production uses app.
 * Matches provision-customer-data EHR config and the app-level helper in
 * src/util/elation.ts.
 */
const isDevHost = (hostname: string): boolean =>
  [
    hostname.endsWith('.apps.dev.lifeomic.com'),
    hostname.endsWith('.localhost'),
    hostname === 'localhost',
  ].some(Boolean);

export const getElationPatientChartUrl = (
  elationId?: string,
  hostname?: string,
): string => {
  if (!elationId) {
    return '';
  }

  const resolvedHostname =
    hostname ??
    (typeof window !== 'undefined' ? window.location.hostname : 'localhost');
  const elationSubdomain = isDevHost(resolvedHostname) ? 'sandbox' : 'app';

  return `https://${elationSubdomain}.elationemr.com/patient/${encodeURIComponent(
    elationId,
  )}/`;
};
